import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../layouts';
import configBase from '../../../configBase';
import axios from 'axios';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import VisibilityIcon from '@material-ui/icons/Visibility';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';


class Faturas extends React.Component {
	_isMounted = false;

	constructor(props) {
		super(props);

		this.state = {
			data: 'loading',
			showTable: false,
			dialogoDetalhes: false,

			errorRequest: false,
			msgErrorRequest: '',
			successRequest: false,
			msgSuccessRequest: '',

			faturaAtual: {
				valor: '',
				referencia: '',
				vencimento: '',
				statusPagamento: '',
			},
			faturaSelecionada: {
				valor: '',
				referencia: '',
				vencimento: '',
				statusPagamento: '',
				urlPlanilha: '',
				quantidadeTotalVidas: {
					pessoaFisica: '',
					pessoaJuridica: '',
					inclusoes: '',
					total: '',
				},
				boleto: {
					url: '',
					linhaDigitavel: '',
				},
			},
		};

		this.styles = {
			theadTr: {
				textTransform: "uppercase",
			},
			theadTh: {
				height: 35,
			},
			inputSearch: {
				marginLeft: 8,
				flex: 1,
			},
		};
	}

	componentDidMount() {
		this._isMounted = true;
		this.getFaturas();
	}
    
	componentWillUnmount() {
		this._isMounted = false;
	}

	getFaturas() {
		let url = configBase.api + 'Faturas?filter={"order": "created DESC"}&access_token=' + localStorage.getItem('planos_t');

		axios.get(url)
		.then((response) => {
			if (this._isMounted) {
				let state = this.state;

				if (response.data.length === 0)
					state.data = 'zero';
				else {
					state.faturaAtual = response.data[0];
					state.data = response.data.slice(1) || [];
				}

				if (state.showTable === false) {
					state.showTable = true;
					$(document).ready(function () {
						let table = $('#table_id').DataTable({
							"dom": 'rtip',
							"language": {
								"url": `${process.env.PUBLIC_URL}/plugins/datatables/Portuguese-Brasil.lang`
							},
							"infoCallback": function( settings, start, end, max, total, pre ) {
								const tablePageStart = document.getElementById('tablePageStart');
								if (tablePageStart) tablePageStart.innerHTML = start;

								const tablePageEnd = document.getElementById('tablePageEnd');
								if (tablePageEnd) tablePageEnd.innerHTML = end;

								const tablePageTotal = document.getElementById('tablePageTotal');
								if (tablePageTotal) tablePageTotal.innerHTML = total;
								
								return '';
							},
							pagingType: "simple",
							oLanguage: {
								oPaginate: {
									sNext: '<svg class="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small"><path d="M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"></path></svg>',
									sPrevious: '<svg class="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small"><path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path></svg>'
								},
							},
							"scrollX": true,
						});

						$('#mySearchText').on( 'keyup', function () {
							table.search($('#mySearchText').val()).draw();
						} );

						$('#myLengthMenu').on( 'change', function () {
							table.page.len($('#myLengthMenu').val()).draw();
						} );
					});
				}
				this.setState(state);
			}
		})
		.catch(() => {
			if (this._isMounted) {
				this.setError('Problema encontrado ao buscar faturas');
			}
		});
	}

	getStatusColor(status) {
		switch (status) {
			case 'PAGO':
				return { backgroundColor: '#4caf50', color: '#ffffff' }
			case 'PENDENTE':
				return { backgroundColor: '#ff7300', color: '#ffffff' }
			case 'ERRO':
				return { backgroundColor: '#f44336', color: '#ffffff' }
			default:
				return { backgroundColor: '#dddddd', color: '#333333' }
		}
	}

	abrirUrl(url) {
		if (!url) return;

		window.open(url, '_blank');
	}

	abrirDialogoDetalhes(fatura) {
    let state = this.state;
		state.faturaSelecionada = fatura;
    state.dialogoDetalhes = true;
    this.setState(state);
  }

  handleCloseDetalhes() {
    let state = this.state;
    state.dialogoDetalhes = false;
    this.setState(state);
  }

	formatValueToDisplay(value) {
		if (!value) {
			return '';
		}

		return parseFloat(value.replace(',', '.')).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
	}

	retornaTextoStatus(value) {
		switch (value) {
			case 'PAGO':
				return 'PAGO';
			case 'PENDENTE':
				return 'PENDENTE';
			case 'ERRO':
				return 'ERRO';
			default:
				return 'Não emitida';
		}
	}

	formatarData(data) {
		if (!data) {
			return '';
		}

		let apenasData = data.split('T')[0];
		let [ano, mes, dia] = apenasData.split('-');
		return `${dia}/${mes}/${ano}`;
	}

	copiarTexto(texto) {
		let state = this.state;
		navigator.clipboard.writeText(texto)
		this.setSuccess('Linha digitável copiada para área de transferência');
		this.setState(state);
	}

	setError(msg) {
		let state = this.state;
		state.errorRequest = true;
		state.msgErrorRequest = msg;
		this.setState(state);
	}

	errorClose = () => {
		let state = this.state;
		state.errorRequest = false;
		state.msgErrorRequest = '';
		this.setState(state);
	}

	setSuccess(msg) {
		let state = this.state;
		state.successRequest = true;
		state.msgSuccessRequest = msg;
		this.setState(state);
	}

	successClose = () => {
		let state = this.state;
		state.successRequest = false;
		state.msgSuccessRequest = '';
		this.setState(state);
	}

	render() {
		const { data } = this.state;

		return (
			<MainLayout history={this.props.history}>
				<div id="Faturas" className={{flexGrow: 1}}>
					<Paper elevation={0} className="paper">
						<Grid container spacing={0}>
							<Grid item xs={12} sm={4} md={4} lg={4}>
								<Typography variant="button" gutterBottom style={{marginLeft: 6}}>
									Faturas
								</Typography>
							</Grid>
						</Grid>
					</Paper>

					<div id="FaturasConteudo" className="contentepanel">
						{
							data === 'loading' ? (
								<Grid container spacing={0}>
									<Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
									<Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center', marginTop: 40}}>
										<LinearProgress />
										<Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
											BUSCANDO FATURAS...
										</Typography>
									</Grid>
									<Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
								</Grid>
							) : (
								data === 'error' ? (
									<Grid container spacing={0}>
										<Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
										<Grid item xs={12} sm={12} md={6} lg={6}>
											<Alert severity="error">Problema ao buscar lista de Faturas</Alert>
										</Grid>
										<Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
									</Grid>
								) : (
									data === 'zero' ? (
										<Grid container spacing={0}>
											<Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
											<Grid item xs={12} sm={12} md={6} lg={6}>
												<Alert severity="info">Nenhuma fatura cadastrada</Alert>
											</Grid>
											<Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
										</Grid>
									) : (
										<div id="FaturasTabela">
											{/* ############# CSS PARA DATATABLE ############# */}
											<link
												rel="stylesheet" type="text/css"
												href="https://cdnjs.cloudflare.com/ajax/libs/material-design-lite/1.1.0/material.min.css"
											/>
											<link
												rel="stylesheet" type="text/css"
												href="https://cdn.datatables.net/1.10.19/css/dataTables.material.min.css"
											/>
											{/* ############# CSS PARA DATATABLE ############# */}

											<Card elevation={4} style={{ borderRadius: 12 }}>
												<CardContent>
													<Grid container spacing={2} alignItems="center">
														<Grid item xs={12} md={8}>
															<Typography variant="subtitle2" color="textSecondary">
																Fatura atual
															</Typography>

															<Typography variant="h4" style={{ fontWeight: 'bold', marginTop: 8 }}>
																{this.formatValueToDisplay(this.state.faturaAtual.valor)}
															</Typography>

															<Typography variant="body2" style={{ marginTop: 8 }} >
																Período: {this.formatarData(this.state.faturaAtual.dataInicial)} até {this.formatarData(this.state.faturaAtual.dataFinal)}
															</Typography>

															{
																this.state.faturaAtual.statusPagamento === 'PAGO' ? (
																	<Typography variant="body2" style={{ marginTop: 8 }} >
																		Pagamento recebido em {this.formatarData(this.state.faturaAtual.dataPagamento)}
																	</Typography>
																) : (
																	<Typography variant="body2" style={{ marginTop: 8 }} >
																		Vencimento: {this.formatarData(this.state.faturaAtual.vencimento) || 'Não definido'}
																	</Typography>
																)
															}

															<div style={{ marginTop: 12 }}>
																<Chip
																	label={this.retornaTextoStatus(this.state.faturaAtual.statusPagamento)}
																	style={this.getStatusColor(this.state.faturaAtual.statusPagamento)}
																/>
															</div>
														</Grid>

														<Grid item xs={12} md={4} style={{ textAlign: 'right' }}>
															{
																this.state.faturaAtual.boleto && this.state.faturaAtual.boleto.url &&
																this.state.faturaAtual.statusPagamento === 'PENDENTE' ? (
																	<Button
																		variant="contained"
																		color="primary"
																		fullWidth
																		style={{
																			backgroundColor: configBase.corPrincipal,
																			color: configBase.corSecundaria,
																			marginBottom: 8
																		}}
																		onClick={() => this.abrirUrl(this.state.faturaAtual.boleto.url)}
																	>
																		Visualizar boleto
																	</Button>
																) : ('')
															}

															<Button
																variant="outlined"
																color="primary"
																fullWidth
																style={{color: configBase.corPrincipal}}
																onClick={this.abrirDialogoDetalhes.bind(this, this.state.faturaAtual)}
															>
																Ver detalhes
															</Button>
														</Grid>
													</Grid>
												</CardContent>
											</Card>

											<Grid container spacing={0} style={{ marginTop: '20px' }}>
												<Grid item xs={12} sm={12} md={4} lg={4}>
													<Typography variant="button" gutterBottom>
														Faturas anteriores
													</Typography>
												</Grid>
												<Grid item xs={12} sm={12} md={4} lg={4}>{''}</Grid>
												<Grid item xs={12} sm={12} md={4} lg={4} style={{marginBottom: 20}}>
													<Paper elevation={1}>
														<IconButton style={{padding: '6px 5px'}} aria-label="search">
															<SearchIcon />
														</IconButton>
														<InputBase
															id="mySearchText"
															style={this.styles.inputSearch}
															placeholder="Pesquisar"
															inputProps={{ 'aria-label': 'search google maps' }}
														/>
													</Paper>
												</Grid>
											</Grid>

											<table id="table_id" className="mdl-data-table table-striped display nowrap" style={{width:'100%'}}>
												<thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
													<tr style={this.styles.theadTr}>
														<th style={this.styles.theadTh}>
															<Typography
																variant="button" display="block" gutterBottom
																style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
															>
																Referência
															</Typography>
														</th>
														<th style={this.styles.theadTh}>
															<Typography
																variant="button" display="block" gutterBottom
																style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
															>
																Valor
															</Typography>
														</th>
														<th style={this.styles.theadTh}>
															<Typography
																variant="button" display="block" gutterBottom
																style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
															>
																Status
															</Typography>
														</th>
														<th style={this.styles.theadTh}>
															<Typography
																variant="button" display="block" gutterBottom
																style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
															>
																AÇÕES
															</Typography>
														</th>
													</tr>
												</thead>

												<tbody>
													{
														data.map((item, index) => {
															return (
																<tr
																	key={index}
																	className="row_table"
																	style={this.styles.theadTh}
																>
																	<td style={{padding: 0, height: 40}}>
																		<Typography variant="overline" display="block" gutterBottom
																			style={{color: '#757575', margin: 0, fontSize: 11}}
																		>
																			{item.referencia}
																		</Typography>
																	</td>
																	<td style={{padding: 0, height: 40}}>
																		<Typography variant="overline" display="block" gutterBottom
																			style={{color: '#757575', margin: 0, fontSize: 11}}
																		>
																			{this.formatValueToDisplay(item.valor)}
																		</Typography>
																	</td>
																	<td style={{padding: 0, height: 40}}>
																		<Typography variant="overline" display="block" gutterBottom
																			style={{color: '#757575', margin: 0, fontSize: 11}}
																		>
																			<Chip
																				label={this.retornaTextoStatus(item.statusPagamento)}
																				style={this.getStatusColor(item.statusPagamento)}
																			/>
																		</Typography>
																	</td>
																	<td style={{padding: 0, height: 40}}>
																		<div>
																			<IconButton
																				aria-label="edit"
																				style={{padding: '8px 8px'}}
																				onClick={this.abrirDialogoDetalhes.bind(this, item)}
																			>
																				<VisibilityIcon />
																			</IconButton>
																		</div>
																	</td>
																</tr>
															)
														})
													}
												</tbody>
											</table>

											<div style={{height: 48, backgroundColor: '#ffffff', color: '#707070', paddingTop: 14, borderTop: '2px solid #eee'}}>
												<div style={{position: 'relative', float: 'right', right: 100, fontSize: 12}}>
													<label htmlFor="myLengthMenu">Linhas por página: </label>
													<select id="myLengthMenu" style={{background: 'transparent', border: 'none', marginLeft: 10, color: '#707070'}}>
														<option value="10">10</option>
														<option value="25">25</option>
														<option value="50">50</option>
														<option value="100">100</option>
													</select>
													<span id="tablePageStart" style={{marginLeft: 15}}></span>-<span id="tablePageEnd"></span>
													{' '}de{' '}
													<span id="tablePageTotal"></span>
												</div>
											</div>
										</div>
									)
								)
							)
						}
					</div>

					<Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose}>
						<MuiAlert className="snackbarStyle" onClose={this.errorClose} severity="error" variant="filled" elevation={6}>
							{this.state.msgErrorRequest}
						</MuiAlert>
					</Snackbar>

					<Snackbar open={this.state.successRequest} autoHideDuration={5000} onClose={this.successClose}>
						<MuiAlert className="snackbarStyle" onClose={this.successClose} severity="success" variant="filled" elevation={6}>
							{this.state.msgSuccessRequest}
						</MuiAlert>
					</Snackbar>
				</div>

				<Dialog open={this.state.dialogoDetalhes} onClose={this.handleCloseDetalhes} maxWidth="sm" fullWidth>
      		<DialogTitle style={{paddingBottom: '0px'}}>Detalhes da fatura</DialogTitle>
					<div style={{ fontSize: 14, color: '#666', marginTop: 0, marginLeft: 24, paddingBottom: 12 }}>
						Período: {this.formatarData(this.state.faturaSelecionada.dataInicial)} até {this.formatarData(this.state.faturaSelecionada.dataFinal)}
					</div>

					<DialogContent dividers>
						<Grid container spacing={2}>
							<Grid item xs={6}>
								<Typography variant="body2">
									Referência:
								</Typography>
								<Typography variant="h6">
									{this.state.faturaSelecionada.referencia}
								</Typography>
							</Grid>

							<Grid item xs={6}>
								<Typography variant="body2">
									Status:
								</Typography>
								<Typography variant="h6">
									<Chip
										label={this.retornaTextoStatus(this.state.faturaSelecionada.statusPagamento)}
										style={this.getStatusColor(this.state.faturaSelecionada.statusPagamento)}
									/>
								</Typography>
							</Grid>

							<Grid item xs={12}>
								<Alert severity="info">
									Valor da fatura: {this.formatValueToDisplay(this.state.faturaSelecionada.valor)} <br />
									{
										this.state.faturaSelecionada.statusPagamento === 'PAGO' ? (
											<>Pagamento recebido em {this.formatarData(this.state.faturaSelecionada.dataPagamento)}</>
										) : (
											<>Vencimento: {this.formatarData(this.state.faturaSelecionada.vencimento) || 'Não definido'}</>
										)
									}
								</Alert>
							</Grid>

							<Grid item xs={12}>
								<Typography variant="body2">
									Quantidade de vidas:
								</Typography>
								<table style={{width: '100%', marginTop: 12}}>
									<thead style={{backgroundColor: configBase.corPrincipal}}>
										<tr>
											<th style={{color: configBase.corSecundaria, fontSize: 12, padding: 8}}>Tipo de vida</th>
											<th style={{color: configBase.corSecundaria, fontSize: 12, padding: 8}}>Vidas implantadas</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td style={{padding: 8}}>Pessoa física</td>
											<td style={{padding: 8}}>{this.state.faturaSelecionada.quantidadeTotalVidas.pessoaFisica}</td>
										</tr>
										<tr>
											<td style={{padding: 8}}>Pessoa jurídica</td>
											<td style={{padding: 8}}>{this.state.faturaSelecionada.quantidadeTotalVidas.pessoaJuridica}</td>
										</tr>
										<tr>
											<td style={{padding: 8}}>Inclusões</td>
											<td style={{padding: 8}}>{this.state.faturaSelecionada.quantidadeTotalVidas.inclusoes}</td>
										</tr>
										<tr>
											<td style={{padding: 8}}>Total</td>
											<td style={{padding: 8}}>{this.state.faturaSelecionada.quantidadeTotalVidas.total}</td>
										</tr>
									</tbody>
								</table>
							</Grid>

							{
								this.state.faturaSelecionada.urlPlanilha ? (
									<Grid item xs={12}>
										<Button
											variant="contained"
											color="primary"
											fullWidth
											style={{
												backgroundColor: configBase.corPrincipal,
												color: configBase.corSecundaria,
												marginBottom: 8
											}}
											onClick={() => this.abrirUrl(this.state.faturaSelecionada.urlPlanilha)}
										>
											Ver extrato
										</Button>
									</Grid>
								) : ('')
							}

							{
								this.state.faturaSelecionada.boleto && this.state.faturaSelecionada.boleto.linhaDigitavel &&
								this.state.faturaSelecionada.statusPagamento === 'PENDENTE' ? (
									<Grid item xs={12}>
										<TextField
											label="Linha digitável"
											fullWidth
											value={this.state.faturaSelecionada.boleto.linhaDigitavel}
											InputProps={{
												readOnly: true,
											}}
										/>
									</Grid>
								) : ('')
							}

							{
								this.state.faturaSelecionada.boleto && this.state.faturaSelecionada.boleto.linhaDigitavel &&
								this.state.faturaSelecionada.statusPagamento === 'PENDENTE' ? (
									<Grid item xs={6}>
										<Button
											variant="contained"
											color="primary"
											fullWidth
											style={{
												backgroundColor: configBase.corPrincipal,
												color: configBase.corSecundaria,
												marginBottom: 8
											}}
											onClick={() => this.abrirUrl(this.state.faturaSelecionada.boleto.url)}
										>
											Imprimir boleto
										</Button>
									</Grid>
								) : ('')
							}

							{
								this.state.faturaSelecionada.boleto && this.state.faturaSelecionada.boleto.linhaDigitavel &&
								this.state.faturaSelecionada.statusPagamento === 'PENDENTE' ? (
									<Grid item xs={6}>
										<Button
											variant="contained"
											color="primary"
											fullWidth
											style={{
												backgroundColor: configBase.corPrincipal,
												color: configBase.corSecundaria,
												marginBottom: 8
											}}
											onClick={() => this.copiarTexto(this.state.faturaSelecionada.boleto.linhaDigitavel)}
										>
											Copiar código
										</Button>
									</Grid>
								) : ('')
							}
						</Grid>
					</DialogContent>

					<DialogActions>
						<Button
							color="primary"
							onClick={this.handleCloseDetalhes.bind(this)}
							style={{
								color: configBase.corPrincipal,
							}}
						>
							Fechar
						</Button>
					</DialogActions>
    		</Dialog>
			</MainLayout>
		);
	}
}

Faturas.propTypes = {
	history: PropTypes.object
};

export default withRouter(Faturas);